// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Nps$ReactHooksTemplate = require("./Nps.res.js");
var NpsLabel$ReactHooksTemplate = require("./NpsLabel.res.js");
var CustomerInfo$ReactHooksTemplate = require("./CustomerInfo.res.js");
var Substitution$ReactHooksTemplate = require("../common/Substitution.res.js");
var SurveyLanguage$ReactHooksTemplate = require("./surveyLanguage.res.js");
var MandatoryMessage$ReactHooksTemplate = require("./MandatoryMessage.res.js");
var NpsRepresentationConfig$ReactHooksTemplate = require("./NpsRepresentationConfig.res.js");

function colorBasedOnLikelyness(scale, index) {
  if (scale === "FiveScale") {
    if (index > 4 || index < 0) {
      if (index !== 5) {
        return "#ffffff";
      } else {
        return "#21AD04";
      }
    } else if (index >= 4) {
      return "#F79406";
    } else {
      return "#E60000";
    }
  } else if (index > 8 || index < 0) {
    if (index === 10 || index === 9) {
      return "#21AD04";
    } else {
      return "#ffffff";
    }
  } else if (index >= 7) {
    return "#F79406";
  } else {
    return "#E60000";
  }
}

function normalizeConfiguration(config) {
  if (config === undefined) {
    return ;
  }
  var match = Js_json.decodeObject(config);
  if (match !== undefined) {
    return config;
  }
  var s = Js_json.decodeString(config);
  if (s === undefined) {
    return ;
  }
  try {
    var parsed = JSON.parse(s);
    var match$1 = Js_json.decodeObject(parsed);
    if (match$1 !== undefined) {
      return parsed;
    } else {
      return ;
    }
  }
  catch (exn){
    return ;
  }
}

function getConfigString(json, key) {
  var d = Js_json.decodeObject(json);
  if (d !== undefined) {
    return Belt_Option.flatMap(Js_dict.get(d, key), Js_json.decodeString);
  }
  
}

function getConfigNumber(json, key) {
  var d = Js_json.decodeObject(json);
  if (d === undefined) {
    return ;
  }
  var __x = Belt_Option.flatMap(Js_dict.get(d, key), Js_json.decodeNumber);
  return Belt_Option.map(__x, (function (prim) {
                return prim | 0;
              }));
}

function decodeConfigItem(json) {
  return {
          value: Json_decode.field("value", Json_decode.$$int, json),
          content: Json_decode.optional((function (param) {
                  return Json_decode.field("content", Json_decode.string, param);
                }), json),
          url: Json_decode.optional((function (param) {
                  return Json_decode.field("url", Json_decode.string, param);
                }), json),
          inline: Json_decode.optional((function (param) {
                  return Json_decode.field("inline", Json_decode.string, param);
                }), json),
          color: Json_decode.optional((function (param) {
                  return Json_decode.field("color", Json_decode.string, param);
                }), json)
        };
}

function getConfigItems(json) {
  var arr = Json_decode.optional((function (param) {
          return Json_decode.field("items", (function (param) {
                        return Json_decode.array(decodeConfigItem, param);
                      }), param);
        }), json);
  if (arr !== undefined) {
    return arr;
  } else {
    return Belt_List.toArray(/* [] */0);
  }
}

function defaultEmojiForValue(value) {
  if (value > 6 || value < 0) {
    if (value > 10 || value < 7) {
      return "😐";
    } else {
      return "😊";
    }
  } else if (value >= 4) {
    return "😐";
  } else {
    return "😞";
  }
}

function categoryForValue(ranges, value) {
  if (value >= ranges.detractor.min && value <= ranges.detractor.max) {
    return "detractor";
  } else if (value >= ranges.passive.min && value <= ranges.passive.max) {
    return "passive";
  } else if (value >= ranges.promoter.min && value <= ranges.promoter.max) {
    return "promoter";
  } else {
    return ;
  }
}

function defaultStarOutlineSvg(strokeColor) {
  return "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" class=\"small:w-8 small:h-8 w-12 h-12\"><path d=\"M12 2l2.4 7.4h7.6l-6 4.6 2.3 7-6.3-4.6-6.3 4.6 2.3-7-6-4.6h7.6z\" fill=\"none\" stroke=\"" + strokeColor + "\" stroke-width=\"1.5\" stroke-linejoin=\"round\"/></svg>";
}

function defaultStarFilledSvg(fillColor) {
  return "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" class=\"small:w-8 small:h-8 w-12 h-12\"><path d=\"M12 2l2.4 7.4h7.6l-6 4.6 2.3 7-6.3-4.6-6.3 4.6 2.3-7-6-4.6h7.6z\" fill=\"" + fillColor + "\" stroke=\"none\"/></svg>";
}

function NpsConfigurableForm(props) {
  var substitutionVariables = props.substitutionVariables;
  var contentOnly = props.contentOnly;
  var overrideQuestionBlock = props.overrideQuestionBlock;
  var onChange = props.onChange;
  var mandatory = props.mandatory;
  var language = props.language;
  var nps = props.nps;
  var scale = Nps$ReactHooksTemplate.scale(nps);
  var includeZero = Nps$ReactHooksTemplate.includeZero(nps);
  var startRating = includeZero ? 0 : 1;
  var endRating;
  endRating = scale === "FiveScale" ? 5 : 10;
  var labelPadding;
  labelPadding = scale === "FiveScale" ? "lg:px-16" : "";
  var rmName = CustomerInfo$ReactHooksTemplate.rmName(props.customerInfo);
  var questionText = Nps$ReactHooksTemplate.getTextTranslation(nps, SurveyLanguage$ReactHooksTemplate.name(language)).replace("${RM_NAME}", rmName);
  var configObj = normalizeConfiguration(props.configuration);
  var scaleStringForCategories = NpsRepresentationConfig$ReactHooksTemplate.scaleStringFromNps(scale, includeZero);
  var categoryRanges = NpsRepresentationConfig$ReactHooksTemplate.getCategoryRangesFromConfig(configObj, scaleStringForCategories);
  var categoryColors = NpsRepresentationConfig$ReactHooksTemplate.getCategoryColorsFromConfig(configObj);
  var visualType = Belt_Option.flatMap(configObj, (function (c) {
          return getConfigString(c, "visualType");
        }));
  var filledChar = Belt_Option.getWithDefault(Belt_Option.flatMap(configObj, (function (c) {
              return getConfigString(c, "filledChar");
            })), "★");
  var emptyChar = Belt_Option.getWithDefault(Belt_Option.flatMap(configObj, (function (c) {
              return getConfigString(c, "emptyChar");
            })), "☆");
  var starCount = Belt_Option.getWithDefault(Belt_Option.flatMap(configObj, (function (c) {
              return getConfigNumber(c, "count");
            })), (endRating - startRating | 0) + 1 | 0);
  var itemsArray = Belt_Option.getWithDefault(Belt_Option.map(configObj, getConfigItems), Belt_List.toArray(/* [] */0));
  var findItem = function (v) {
    return Belt_Array.getBy(itemsArray, (function (x) {
                  return x.value === v;
                }));
  };
  var questionBlock;
  if (overrideQuestionBlock !== undefined) {
    questionBlock = Caml_option.valFromOption(overrideQuestionBlock);
  } else {
    var titleHtml = Substitution$ReactHooksTemplate.renderQuestionText(questionText, substitutionVariables) + (
      mandatory ? " *" : ""
    );
    var descriptionHtml = Substitution$ReactHooksTemplate.renderQuestionText(Nps$ReactHooksTemplate.getDescriptionTranslation(nps, SurveyLanguage$ReactHooksTemplate.name(language)), substitutionVariables);
    questionBlock = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
                  className: "survey-rich-text text-lg font-medium text-darkcharcoal py-6 whitespace-pre-line",
                  dangerouslySetInnerHTML: {
                    __html: titleHtml
                  }
                }),
            JsxRuntime.jsx("div", {
                  className: "survey-rich-text text-base font-normal text-darkcharcoal pb-8 whitespace-pre-line",
                  dangerouslySetInnerHTML: {
                    __html: descriptionHtml
                  }
                })
          ]
        });
  }
  var selectedCss = function (v) {
    if (Nps$ReactHooksTemplate.isAnswer(nps, v)) {
      return "border-2 border-bleudefrance";
    } else {
      return "";
    }
  };
  var baseCss = "rounded-xl focus:outline-none text-lg font-medium";
  var selectionMotionCss = "transform transition-transform duration-300 ease-out origin-center";
  var selectionScaleCss = function (v) {
    if (Nps$ReactHooksTemplate.isAnswer(nps, v)) {
      return "scale-110";
    } else {
      return "";
    }
  };
  var stepValues = Belt_List.makeBy((endRating - startRating | 0) + 1 | 0, (function (i) {
          return startRating + i | 0;
        }));
  var renderCell = function (v) {
    var onClick = function (param) {
      Curry._1(onChange, Nps$ReactHooksTemplate.setAnswer(nps, v));
    };
    if (visualType !== undefined) {
      switch (visualType) {
        case "emoji" :
            var it = findItem(v);
            var content = it !== undefined ? Belt_Option.getWithDefault(it.content, defaultEmojiForValue(v)) : defaultEmojiForValue(v);
            return JsxRuntime.jsx("button", {
                        children: content,
                        className: " " + baseCss + " text-2xl w-12 h-12 rounded " + selectionMotionCss + " " + selectionScaleCss(v),
                        type: "button",
                        onClick: onClick
                      }, String(v));
        case "star" :
            var hasItems = itemsArray.length !== 0;
            if (hasItems) {
              var it$1 = findItem(v);
              var current = Belt_Option.getWithDefault(Nps$ReactHooksTemplate.rating(nps), startRating - 1 | 0);
              var filled = v <= current;
              var match = categoryForValue(categoryRanges, v);
              var color;
              if (match !== undefined) {
                switch (match) {
                  case "detractor" :
                      color = categoryColors.detractor;
                      break;
                  case "passive" :
                      color = categoryColors.passive;
                      break;
                  case "promoter" :
                      color = categoryColors.promoter;
                      break;
                  default:
                    color = colorBasedOnLikelyness(scale, v);
                }
              } else {
                color = colorBasedOnLikelyness(scale, v);
              }
              var defaultStarSvg = filled ? defaultStarFilledSvg(color) : defaultStarOutlineSvg(color);
              var starHtml;
              if (it$1 !== undefined) {
                var match$1 = it$1.inline;
                var match$2 = it$1.url;
                starHtml = match$1 !== undefined ? (
                    match$1 !== "" ? match$1 : defaultStarSvg
                  ) : (
                    match$2 !== undefined && match$2 !== "" ? "<img src=\"" + match$2 + "\" alt=\"\" class=\"small:w-8 small:h-8 w-12 h-12 object-contain\" />" : defaultStarSvg
                  );
              } else {
                starHtml = defaultStarSvg;
              }
              var useImg = Belt_Option.isSome(Belt_Option.flatMap(it$1, (function (x) {
                          return x.url;
                        }))) && Belt_Option.isNone(Belt_Option.flatMap(it$1, (function (x) {
                          return x.inline;
                        })));
              var tmp;
              if (useImg) {
                var src = Belt_Option.flatMap(it$1, (function (x) {
                        return x.url;
                      }));
                tmp = src !== undefined ? JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx("img", {
                              className: "small:w-8 small:h-8 w-12 h-12 object-contain",
                              alt: "",
                              src: src
                            }),
                        className: "absolute inset-0 flex items-center justify-center"
                      }) : null;
              } else {
                tmp = JsxRuntime.jsx("span", {
                      className: "absolute inset-0 flex items-center justify-center small:w-8 small:h-8 w-12 h-12",
                      dangerouslySetInnerHTML: {
                        __html: starHtml
                      }
                    });
              }
              return JsxRuntime.jsxs("button", {
                          children: [
                            tmp,
                            null
                          ],
                          className: "rounded p-0 small:w-8 small:h-8 w-12 h-12 flex items-center justify-center relative focus:outline-none " + selectionMotionCss + " " + selectionScaleCss(v),
                          type: "button",
                          onClick: onClick
                        }, String(v));
            }
            var current$1 = Belt_Option.getWithDefault(Nps$ReactHooksTemplate.rating(nps), -1);
            var filled$1 = v <= current$1;
            var chars = Belt_List.reduce(Belt_List.makeBy(starCount, (function (i) {
                        if (i < (
                            filled$1 ? (v - startRating | 0) + 1 | 0 : 0
                          )) {
                          return filledChar;
                        } else {
                          return emptyChar;
                        }
                      })), "", (function (a, c) {
                    return a + c;
                  }));
            return JsxRuntime.jsx("button", {
                        children: chars,
                        className: " " + selectedCss(v) + " " + baseCss + " px-3 py-2 border border-gray-300 " + selectionMotionCss + " " + selectionScaleCss(v),
                        type: "button",
                        onClick: onClick
                      }, String(v));
        case "svg" :
            var inner = Belt_Option.flatMap(findItem(v), (function (it) {
                    return it.inline;
                  }));
            var exit = 0;
            if (inner !== undefined) {
              if (inner !== "") {
                return JsxRuntime.jsx("button", {
                            children: JsxRuntime.jsx("span", {
                                  dangerouslySetInnerHTML: {
                                    __html: inner
                                  }
                                }),
                            className: " " + selectedCss(v) + " rounded p-1 w-12 h-12 flex items-center justify-center " + selectionMotionCss + " " + selectionScaleCss(v),
                            type: "button",
                            onClick: onClick
                          }, String(v));
              }
              exit = 2;
            } else {
              exit = 2;
            }
            if (exit === 2) {
              return JsxRuntime.jsx("button", {
                          children: String(v),
                          className: " " + selectedCss(v) + " " + baseCss + " w-12 h-12 " + selectionMotionCss + " " + selectionScaleCss(v),
                          type: "button",
                          onClick: onClick
                        }, String(v));
            }
            break;
        default:
          
      }
    }
    return JsxRuntime.jsx("button", {
                children: String(v),
                className: " " + selectedCss(v) + " " + baseCss + " small:w-8 small:h-8 w-12 h-12 text-white " + selectionMotionCss + " " + selectionScaleCss(v),
                style: {
                  backgroundColor: NpsRepresentationConfig$ReactHooksTemplate.colorForStepValue(scaleStringForCategories, v, categoryRanges, categoryColors)
                },
                type: "button",
                onClick: onClick
              }, String(v));
  };
  var cells = $$Array.of_list(Belt_List.map(stepValues, renderCell));
  var tmp;
  tmp = scale === "FiveScale" ? null : JsxRuntime.jsx("p", {
          children: NpsLabel$ReactHooksTemplate.center(Nps$ReactHooksTemplate.getLabelTranslation(nps, SurveyLanguage$ReactHooksTemplate.name(language))),
          className: "pl-12"
        });
  var cellsAndLabels = JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [
          JsxRuntime.jsx("div", {
                children: cells,
                className: "flex w-full justify-center gap-2"
              }),
          JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("p", {
                        children: NpsLabel$ReactHooksTemplate.left(Nps$ReactHooksTemplate.getLabelTranslation(nps, SurveyLanguage$ReactHooksTemplate.name(language)))
                      }),
                  tmp,
                  JsxRuntime.jsx("p", {
                        children: NpsLabel$ReactHooksTemplate.right(Nps$ReactHooksTemplate.getLabelTranslation(nps, SurveyLanguage$ReactHooksTemplate.name(language)))
                      })
                ],
                className: " flex justify-between w-full pt-6 pb-10 text-spanishgray text-sm " + labelPadding + " "
              })
        ]
      });
  if (contentOnly !== undefined && contentOnly) {
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx("div", {
                      children: cellsAndLabels,
                      className: "flex flex-col w-full"
                    }),
                className: "flex w-full"
              });
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: questionBlock
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              cellsAndLabels,
                              mandatory ? JsxRuntime.jsx(MandatoryMessage$ReactHooksTemplate.make, {
                                      language: language
                                    }) : null
                            ],
                            className: "flex flex-col w-full"
                          }),
                      className: "flex w-full"
                    })
              ],
              className: "w-full px-16 small:px-6 " + props.borderCss
            });
}

var make = NpsConfigurableForm;

exports.colorBasedOnLikelyness = colorBasedOnLikelyness;
exports.normalizeConfiguration = normalizeConfiguration;
exports.getConfigString = getConfigString;
exports.getConfigNumber = getConfigNumber;
exports.decodeConfigItem = decodeConfigItem;
exports.getConfigItems = getConfigItems;
exports.defaultEmojiForValue = defaultEmojiForValue;
exports.categoryForValue = categoryForValue;
exports.defaultStarOutlineSvg = defaultStarOutlineSvg;
exports.defaultStarFilledSvg = defaultStarFilledSvg;
exports.make = make;
/* react/jsx-runtime Not a pure module */
